import { AbstractEntity } from "../AbstractEntity";
export class FileChunk extends AbstractEntity {
    fileId;
    index;
    data;
    constructor(fileChunk) {
        super();
        Object.assign(this, fileChunk);
    }
}
export default class File extends AbstractEntity {
    filename;
    mimeType;
    size;
    constructor(file = {}) {
        super();
        Object.assign(this, file);
    }
}
//# sourceMappingURL=File.js.map